var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "margin-top": "5px" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "-20px",
                position: "relative",
                "z-index": "1",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "input-common",
                  staticStyle: { width: "120px" },
                  attrs: { placeholder: "Trạng thái" },
                  on: {
                    change: function ($event) {
                      return _vm.changeSearchMethod()
                    },
                  },
                  model: {
                    value: _vm.dataSearch.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "status", $$v)
                    },
                    expression: "dataSearch.status",
                  },
                },
                _vm._l(_vm.kidStatusList, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { value: item.key, label: item.value },
                  })
                }),
                1
              ),
              _vm.activeTabName === "tabName3" ||
              _vm.activeTabName === "tabName4"
                ? _c(
                    "el-select",
                    {
                      staticClass: "input-common input-grade",
                      staticStyle: { width: "203px" },
                      attrs: { placeholder: "Chọn nhóm" },
                      on: { change: _vm.changeSearchMethod },
                      model: {
                        value: _vm.dataSearch.idGroup,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "idGroup", $$v)
                        },
                        expression: "dataSearch.idGroup",
                      },
                    },
                    _vm._l(_vm.kidGroupList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.id, label: item.nameGroup },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm.activeTabName === "tabName1" ||
              _vm.activeTabName === "tabName2"
                ? _c(
                    "el-select",
                    {
                      staticClass: "input-common input-grade",
                      staticStyle: { width: "110px" },
                      attrs: { placeholder: "Chọn khối" },
                      on: {
                        change: function ($event) {
                          return _vm.changeGradeSearch()
                        },
                      },
                      model: {
                        value: _vm.dataSearch.idGrade,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "idGrade", $$v)
                        },
                        expression: "dataSearch.idGrade",
                      },
                    },
                    _vm._l(_vm.gradeOfSchoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.gradeName },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm.activeTabName === "tabName1" ||
              _vm.activeTabName === "tabName2"
                ? _c(
                    "el-select",
                    {
                      staticClass: "input-common input-class",
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "Chọn lớp" },
                      on: {
                        change: function ($event) {
                          return _vm.changeSearchMethod()
                        },
                      },
                      model: {
                        value: _vm.dataSearch.idClass,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "idClass", $$v)
                        },
                        expression: "dataSearch.idClass",
                      },
                    },
                    _vm._l(_vm.classList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.className },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "el-input",
                {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "Nhập tên học sinh", clearable: "" },
                  on: {
                    clear: function ($event) {
                      return _vm.changeSearchMethod()
                    },
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.changeSearchMethod()
                    },
                  },
                  model: {
                    value: _vm.dataSearch.fullName,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "fullName", $$v)
                    },
                    expression: "dataSearch.fullName",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: {
                      click: function ($event) {
                        return _vm.changeSearchMethod()
                      },
                    },
                    slot: "append",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClickTab },
              model: {
                value: _vm.activeTabName,
                callback: function ($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Đăng ký theo lớp", name: "tabName1" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "multipleTable",
                      attrs: {
                        data: _vm.responseTab1DataList,
                        "empty-text": _vm.textTable,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "highlight-current-row": "",
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                      on: { "selection-change": _vm.handleSelectionChangeKids },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          align: "center",
                          width: "55",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          type: "index",
                          label: "STT",
                          width: "50",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          prop: "fullName",
                          "min-width": "170",
                          label: "Họ tên",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ngày sinh",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(scope.row.birthDay)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._l(_vm.headerTab1List, function (item) {
                        return _c("el-table-column", {
                          key: item.id,
                          attrs: { align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top",
                                          align: "center",
                                          width: "200",
                                          trigger: "hover",
                                          content: item.name,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "truncate-text",
                                            attrs: {
                                              slot: "reference",
                                              title: item.name,
                                            },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.name) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("br"),
                                    _c("el-checkbox", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.checkHeaderPackageKidsMethod(
                                            scope.$index,
                                            item.id,
                                            item.check
                                          )
                                        },
                                      },
                                      model: {
                                        value: item.check,
                                        callback: function ($$v) {
                                          _vm.$set(item, "check", $$v)
                                        },
                                        expression: "item.check",
                                      },
                                    }),
                                    item.type === "OUTCLASS"
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Khoản ngoài lớp",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "margin-left": "4px",
                                                  cursor: "pointer",
                                                },
                                              },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.fnKidsPackageList.filter(
                                      (x) => x.fnPackage.id === item.id
                                    ).length === 1
                                      ? _c(
                                          "span",
                                          [
                                            _c("el-checkbox", {
                                              model: {
                                                value:
                                                  scope.row.fnKidsPackageList.filter(
                                                    (x) =>
                                                      x.fnPackage.id === item.id
                                                  )[0].active,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row.fnKidsPackageList.filter(
                                                      (x) =>
                                                        x.fnPackage.id ===
                                                        item.id
                                                    )[0],
                                                    "active",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                    scope.row.fnKidsPackageList.filter(\n                      (x) => x.fnPackage.id === item.id\n                    )[0].active\n                  ",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Tác vụ",
                          fixed: "right",
                          width: "200",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addPackageKidsMethod(
                                          scope.row,
                                          "CLASS"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Thêm\n              ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.activePackageKidsOneMethod(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Lưu\n              ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticStyle: { float: "right", "margin-top": "20px" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "button-bottom",
                          attrs: {
                            loading: _vm.loadingButtonSaveTab1,
                            type: "success",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.activePackageKidsManyMethod()
                            },
                          },
                        },
                        [_vm._v("Lưu\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "Chi tiết học sinh theo lớp",
                    name: "tabName2",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "kidsPackageForKidsRef",
                      attrs: {
                        data: _vm.responseTab2DataList,
                        "empty-text": _vm.textTable,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "cell-style": _vm.tableRowStyleDetail,
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "expand", width: "1" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-table",
                                  {
                                    ref: "kidsPackageForKidsRef1",
                                    attrs: {
                                      data: scope.row
                                        .revenueManagementResponses,
                                      "empty-text": _vm.textTable,
                                      "element-loading-text": _vm.$tableLoading,
                                      "element-loading-spinner":
                                        "el-icon-loading",
                                      "element-loading-background":
                                        "rgba(255,255,255, 0)",
                                      "highlight-current-row": "",
                                      "cell-style": _vm.tableRowStyleChildren,
                                      "header-cell-style":
                                        _vm.tableHeaderChildrenColor,
                                      "max-height": _vm.$tableMaxHeightMini,
                                      border: "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        fixed: "",
                                        type: "index",
                                        label: "STT",
                                        width: "50",
                                        align: "center",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        fixed: "",
                                        label: "Tên khoản",
                                        prop: "name",
                                        "min-width": "150",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        fixed: "",
                                        align: "center",
                                        label: "Trạng thái sử dụng",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (childScope) {
                                              return [
                                                _c("el-checkbox", {
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.activePackageKidsMethod(
                                                        childScope.row,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      childScope.row.active,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        childScope.row,
                                                        "active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "childScope.row.active",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "Loại",
                                        width: "80",
                                        prop: "category",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.category === "in"
                                                  ? _c("span", [_vm._v("Thu")])
                                                  : scope.row.category === "out"
                                                  ? _c("span", [_vm._v("Chi")])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "description",
                                        label: "Mô tả",
                                        "min-width": "200",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "number",
                                        align: "center",
                                        label: "Số lượng",
                                        width: "80",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "right",
                                        label: "Đơn giá",
                                        width: "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatCurrency")(
                                                        scope.row.price
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "discount",
                                        align: "center",
                                        label: "Giảm giá",
                                        width: "80",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.discount
                                                  ? _c("span", [_vm._v("Có")])
                                                  : _c("span", [
                                                      _vm._v("Không"),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "discountPrice",
                                        align: "right",
                                        label: "Đơn giá sau giảm",
                                        width: "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.discount
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatCurrency"
                                                          )(
                                                            scope.row
                                                              .discountPrice
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatCurrency"
                                                          )(scope.row.price)
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "Điểm danh",
                                        width: "85",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.attendance
                                                  ? _c("span", [_vm._v("Có")])
                                                  : _c("span", [
                                                      _vm._v("Không"),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "Tác vụ",
                                        fixed: "right",
                                        width: "140",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (parentScope) {
                                              return [
                                                _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            parentScope.row
                                                              .type === "CLASS",
                                                          size: "mini",
                                                          type: "danger",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deletePackageDefaultMethod(
                                                              scope.row,
                                                              parentScope.row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "button.delete"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          width: "50",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          width: "200",
                          prop: "fullName",
                          label: "Họ tên",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Ngày sinh", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(scope.row.birthDay)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Số khoản", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.revenueManagementResponses
                                        .length
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Tác vụ",
                          width: "110",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.revenueManagementResponses.length > 0
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.expandRow
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toogleExpandDetailDate(
                                                      scope.$index,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Thu nhỏ")]
                                            )
                                          : _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toogleExpandDetailDate(
                                                      scope.$index,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Mở rộng")]
                                            ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Đăng ký theo nhóm", name: "tabName3" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "multipleTable2",
                      attrs: {
                        data: _vm.responseTab3DataList,
                        "empty-text": _vm.textTable,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "highlight-current-row": "",
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                      on: { "selection-change": _vm.handleSelectionChangeKids },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          align: "center",
                          width: "55",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          type: "index",
                          label: "STT",
                          width: "50",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          prop: "fullName",
                          "min-width": "170",
                          label: "Họ tên",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ngày sinh",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(scope.row.birthDay)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._l(_vm.headerTab3List, function (item) {
                        return _c("el-table-column", {
                          key: item.id,
                          attrs: { align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top",
                                          align: "center",
                                          width: "200",
                                          trigger: "hover",
                                          content: item.name,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "truncate-text",
                                            attrs: {
                                              slot: "reference",
                                              title: item.name,
                                            },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.name) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("br"),
                                    _c("el-checkbox", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.checkHeaderPackageKidsMethod(
                                            scope.$index,
                                            item.id,
                                            item.check
                                          )
                                        },
                                      },
                                      model: {
                                        value: item.check,
                                        callback: function ($$v) {
                                          _vm.$set(item, "check", $$v)
                                        },
                                        expression: "item.check",
                                      },
                                    }),
                                    item.type === "OUTGROUP"
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Khoản ngoài nhóm",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "margin-left": "4px",
                                                  cursor: "pointer",
                                                },
                                              },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.fnKidsPackageList.filter(
                                      (x) => x.fnPackage.id === item.id
                                    ).length === 1
                                      ? _c(
                                          "span",
                                          [
                                            _c("el-checkbox", {
                                              model: {
                                                value:
                                                  scope.row.fnKidsPackageList.filter(
                                                    (x) =>
                                                      x.fnPackage.id === item.id
                                                  )[0].active,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row.fnKidsPackageList.filter(
                                                      (x) =>
                                                        x.fnPackage.id ===
                                                        item.id
                                                    )[0],
                                                    "active",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                    scope.row.fnKidsPackageList.filter(\n                      (x) => x.fnPackage.id === item.id\n                    )[0].active\n                  ",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Tác vụ",
                          fixed: "right",
                          width: "200",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addPackageKidsMethod(
                                          scope.row,
                                          "GROUP"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Thêm\n              ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.activePackageKidsOneMethod(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Lưu\n              ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticStyle: { float: "right", "margin-top": "20px" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "button-bottom",
                          attrs: {
                            loading: _vm.loadingButtonSaveTab1,
                            type: "success",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.activePackageKidsManyMethod()
                            },
                          },
                        },
                        [_vm._v("Lưu\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "Chi tiết học sinh theo nhóm",
                    name: "tabName4",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "kidsPackageForKidsRef2",
                      attrs: {
                        data: _vm.responseTab4DataList,
                        "empty-text": _vm.textTable,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "cell-style": _vm.tableRowStyleDetail,
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "expand", width: "1" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-table",
                                  {
                                    ref: "kidsPackageForKidsRef4",
                                    attrs: {
                                      data: scope.row
                                        .revenueManagementResponses,
                                      "empty-text": _vm.textTable,
                                      "element-loading-text": _vm.$tableLoading,
                                      "element-loading-spinner":
                                        "el-icon-loading",
                                      "element-loading-background":
                                        "rgba(255,255,255, 0)",
                                      "highlight-current-row": "",
                                      "cell-style": _vm.tableRowStyleChildren,
                                      "header-cell-style":
                                        _vm.tableHeaderChildrenColor,
                                      "max-height": _vm.$tableMaxHeightMini,
                                      border: "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        fixed: "",
                                        type: "index",
                                        label: "STT",
                                        width: "50",
                                        align: "center",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        fixed: "",
                                        label: "Tên khoản",
                                        prop: "name",
                                        "min-width": "150",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        fixed: "",
                                        align: "center",
                                        label: "Trạng thái sử dụng",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (childScope) {
                                              return [
                                                _c("el-checkbox", {
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.activePackageKidsMethod(
                                                        childScope.row,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      childScope.row.active,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        childScope.row,
                                                        "active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "childScope.row.active",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "Loại",
                                        width: "80",
                                        prop: "category",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.category === "in"
                                                  ? _c("span", [_vm._v("Thu")])
                                                  : scope.row.category === "out"
                                                  ? _c("span", [_vm._v("Chi")])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "description",
                                        label: "Mô tả",
                                        "min-width": "200",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "number",
                                        align: "center",
                                        label: "Số lượng",
                                        width: "80",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "right",
                                        label: "Đơn giá",
                                        width: "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatCurrency")(
                                                        scope.row.price
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "discount",
                                        align: "center",
                                        label: "Giảm giá",
                                        width: "80",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.discount
                                                  ? _c("span", [_vm._v("Có")])
                                                  : _c("span", [
                                                      _vm._v("Không"),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "discountPrice",
                                        align: "right",
                                        label: "Đơn giá sau giảm",
                                        width: "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.discount
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatCurrency"
                                                          )(
                                                            scope.row
                                                              .discountPrice
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatCurrency"
                                                          )(scope.row.price)
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        label: "Điểm danh",
                                        width: "85",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.attendance
                                                  ? _c("span", [_vm._v("Có")])
                                                  : _c("span", [
                                                      _vm._v("Không"),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "Tác vụ",
                                        fixed: "right",
                                        width: "140",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (parentScope) {
                                              return [
                                                _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            parentScope.row
                                                              .type === "GROUP",
                                                          size: "mini",
                                                          type: "danger",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deletePackageDefaultMethod(
                                                              scope.row,
                                                              parentScope.row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "button.delete"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          width: "50",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          width: "200",
                          prop: "fullName",
                          label: "Họ tên",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Ngày sinh", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(scope.row.birthDay)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Số khoản", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.revenueManagementResponses
                                        .length
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Tác vụ",
                          width: "110",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.revenueManagementResponses.length > 0
                                  ? _c(
                                      "span",
                                      [
                                        scope.row.expandRow
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toogleExpandDetailDateGroup(
                                                      scope.$index,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Thu nhỏ")]
                                            )
                                          : _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toogleExpandDetailDateGroup(
                                                      scope.$index,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Mở rộng")]
                                            ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddRevenueOutClassDialog", {
        attrs: {
          idKid: _vm.idKid,
          type: _vm.type,
          dialogVisibleAdd: _vm.dialogVisibleAdd,
          idClass: _vm.dataSearch.idClass,
          idGroup: _vm.dataSearch.idGroup,
        },
        on: { "dialog-close": _vm.dialogCloseAddRevenueOutClassDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }